module.exports = __webpack_public_path__ + "ac16fd55cb279e8f1105a9485a9e56f8.svg";